export default {
    COMPANY_OWNERS: 'Vlasnici kompanija',
    END_USERS: 'Krajnji korisnici',
    COMPANIES: 'Kompanije',
    WEBSITES: 'Websajtovi',
    TERMINALS: 'Terminali',
    PLACES: 'Lokali',
    PRODUCTS: 'Proizvodi',
    PRODUCT_CATEGORIES: 'Kategorije proizvoda',
    NESTED_PRODUCTS: 'Prilozi/dodaci',
    NESTED_PRODUCT_CATEGORIES: 'Kategorije priloga/dodataka',
    PROMOTIONS: 'Promocije',
    ORDERS: 'Porudžbine',
};
